import translations from '../translations/lt';

export default (key) => translations[key];
